




















import { IDialog } from "@/lib/interfaces/dialog.interface";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import FleetManagerTree from "./FleetManagerTree.vue";

@Component({
  components: {
    FleetManagerTree
  }
})
export default class FleetManagerTreeDialog extends Vue implements IDialog {
  isDialog = false;
  localSelectedFleetIds: string[] = [];

  open(): void {
    this.isDialog = true;

    this.localSelectedFleetIds = [...FleetManagerModule.selectedFleetIds];
  }

  close(): void {
    this.isDialog = false;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  applySelection() {
    FleetManagerModule.setSelectedFleetIds(this.localSelectedFleetIds);
    this.$emit("confirm");
    this.isDialog = false;
  }
}
